import { createAction } from "redux-actions";

import { createAsyncAction } from "../helpers";

export const getJudgeSettingsAsyncAction = createAsyncAction(
	"GET_JUDGE_SETTINGS_REQUEST",
	"GET_JUDGE_SETTINGS_SUCCESS",
	"GET_JUDGE_SETTINGS_FAILURE",
	"GET_JUDGE_SETTINGS_CANCEL"
);

export const postSettingsAsyncAction = createAsyncAction(
	"POST_JUDGE_SETTINGS_REQUEST",
	"POST_JUDGE_SETTINGS_SUCCESS",
	"POST_JUDGE_SETTINGS_FAILURE",
	"POST_JUDGE_SETTINGS_CANCEL"
);

export const getJudgeProfileListAsyncAction = createAsyncAction(
	"GET_JUDGE_PROFILE_LIST_REQUEST",
	"GET_JUDGE_PROFILE_LIST_SUCCESS",
	"GET_JUDGE_PROFILE_LIST_FAILURE",
	"GET_JUDGE_PROFILE_LIST_CANCEL"
);

export const getJudgeProfileAsyncAction = createAsyncAction(
	"GET_JUDGE_PROFILE_REQUEST",
	"GET_JUDGE_PROFILE_SUCCESS",
	"GET_JUDGE_PROFILE_FAILURE",
	"GET_JUDGE_PROFILE_CANCEL"
);

export const updateJudgeProfileAsyncAction = createAsyncAction(
	"PUT_JUDGE_PROFILE_REQUEST",
	"PUT_JUDGE_PROFILE_SUCCESS",
	"PUT_JUDGE_PROFILE_FAILURE",
	"PUT_JUDGE_PROFILE_CANCEL"
);

export const getQuestionsListAsyncAction = createAsyncAction(
	"GET_JUDGE_QUESTIONS_LIST_REQUEST",
	"GET_JUDGE_QUESTIONS_LIST_SUCCESS",
	"GET_JUDGE_QUESTIONS_LIST_FAILURE",
	"GET_JUDGE_QUESTIONS_LIST_CANCEL"
);

export const getQuestionAsyncAction = createAsyncAction(
	"GET_JUDGE_QUESTION_REQUEST",
	"GET_JUDGE_QUESTION_SUCCESS",
	"GET_JUDGE_QUESTION_FAILURE",
	"GET_JUDGE_QUESTION_CANCEL"
);

export const deleteQuestionsByIdAsyncAction = createAsyncAction(
	"DELETE_JUDGE_QUESTIONS_REQUEST",
	"DELETE_JUDGE_QUESTIONS_SUCCESS",
	"DELETE_JUDGE_QUESTIONS_FAILURE",
	"DELETE_JUDGE_QUESTIONS_CANCEL"
);

export const postQuestionAsyncAction = createAsyncAction(
	"POST_JUDGE_QUESTION_REQUEST",
	"POST_JUDGE_QUESTION_SUCCESS",
	"POST_JUDGE_QUESTION_FAILURE",
	"POST_JUDGE_QUESTION_CANCEL"
);

export const updateQuestionAsyncAction = createAsyncAction(
	"PUT_JUDGE_QUESTION_REQUEST",
	"PUT_JUDGE_QUESTION_SUCCESS",
	"PUT_JUDGE_QUESTION_FAILURE",
	"PUT_JUDGE_QUESTION_CANCEL"
);

export const exportJudgeProfilesDataAsyncAction = createAsyncAction(
	"EXPORT_JUDGE_PROFILES"
);

export const resetAction = createAction("JUDGE_RESET_ACTIONS");
